import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiBriefcase, FiMenu, FiX, FiChevronDown, FiUser, FiGrid, FiLogOut, FiBell, FiSettings } from 'react-icons/fi';
import './Navbar.css';

const Navbar = () => {
  const { user, isAuthenticated, isAdmin, isRecruiter, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav className="navbar">
      <div className="navbar-inner container-wide">
        <Link to="/" className="navbar-brand">
          <FiBriefcase className="brand-icon" />
          <span className="brand-text">Placement<span className="brand-accent">Hunter</span></span>
        </Link>

        <div className={`navbar-links ${mobileOpen ? 'open' : ''}`}>
          <Link to="/jobs" className={`nav-link ${isActive('/jobs') ? 'active' : ''}`}>Browse Jobs</Link>
          <Link to="/companies" className={`nav-link ${isActive('/companies') ? 'active' : ''}`}>Companies</Link>

          {isAuthenticated ? (
            <>
              <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>Dashboard</Link>
              {(isRecruiter || isAdmin) && (
                <Link to="/jobs/create" className={`nav-link ${isActive('/jobs/create') ? 'active' : ''}`}>Post a Job</Link>
              )}
              {isAdmin && (
                <Link to="/admin" className={`nav-link ${isActive('/admin') ? 'active' : ''}`}>Admin</Link>
              )}
            </>
          ) : (
            <Link to="/career-resources" className={`nav-link ${isActive('/career-resources') ? 'active' : ''}`}>Resources</Link>
          )}
        </div>

        <div className="navbar-actions">
          {isAuthenticated ? (
            <>
              <Link to="/notifications" className="nav-icon-btn" title="Notifications">
                <FiBell />
              </Link>
              <div className="nav-dropdown" ref={dropdownRef}>
                <button className="nav-avatar-btn" onClick={() => setDropdownOpen(!dropdownOpen)}>
                  <div className="nav-avatar">{user?.first_name?.[0] || user?.email?.[0] || 'U'}</div>
                  <FiChevronDown className={`chevron ${dropdownOpen ? 'rotated' : ''}`} />
                </button>
                {dropdownOpen && (
                  <div className="dropdown-menu">
                    <div className="dropdown-header">
                      <div className="dropdown-name">{user?.first_name} {user?.last_name}</div>
                      <div className="dropdown-email">{user?.email}</div>
                    </div>
                    <div className="dropdown-divider" />
                    <Link to="/dashboard" className="dropdown-item" onClick={() => setDropdownOpen(false)}><FiGrid /> Dashboard</Link>
                    <Link to="/profile" className="dropdown-item" onClick={() => setDropdownOpen(false)}><FiUser /> Profile</Link>
                    <Link to="/settings" className="dropdown-item" onClick={() => setDropdownOpen(false)}><FiSettings /> Settings</Link>
                    <div className="dropdown-divider" />
                    <button className="dropdown-item logout" onClick={handleLogout}><FiLogOut /> Logout</button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-secondary btn-sm">Sign In</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
            </>
          )}
          <button className="mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
